import Select from 'components/Select';
import { comingOptions } from 'config';
import React from 'react';

const options = Object.entries(comingOptions).map(
  ([id, { name }]) => ({ id, name })
);
export default function ComingSelect({
  name, label
}) {
  return (
    <Select
      options={options}
      name={name}
      label={label}
    />
  );
}
